import { render, staticRenderFns } from "./BtnLoadMoreMessage.vue?vue&type=template&id=781c10df&scoped=true"
import script from "./BtnLoadMoreMessage.vue?vue&type=script&lang=js"
export * from "./BtnLoadMoreMessage.vue?vue&type=script&lang=js"
import style0 from "./BtnLoadMoreMessage.vue?vue&type=style&index=0&id=781c10df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781c10df",
  null
  
)

export default component.exports